import React from "react";
import { CardProps } from "antd/lib/card";
import { Card } from "antd";
import styles from "./styles.less";

export default ({ children, className, ...options }: CardProps) => (
  <Card className={[styles.card, className].join(" ")} {...options}>
    {children}
  </Card>
);
